export interface EventType {
  id: string;
  label: string;
  description: string;
  subscribed: boolean;
  subscribedByImplication: boolean;
  seen: boolean;
}

export interface SubscriptionStatus {
  data: EventType[];
  configured: boolean;
  configuredAt: string | null;
}

export interface ChatNotificationPreferences {
  emailEnabled: boolean;
  emailTiming: 'immediate' | 'unanswered';
  emailUnansweredMinutes: number;
  googleChatEnabled: boolean;
  googleChatTiming: 'immediate' | 'unanswered';
  googleChatUnansweredMinutes: number;
  googleChatConnected: boolean;
  googleUserEmail: string | null;
  teamsChatEnabled: boolean;
  teamsChatTiming: 'immediate' | 'unanswered';
  teamsChatUnansweredMinutes: number;
  teamsChatConnected: boolean;
  teamsUserEmail: string | null;
  slackChatEnabled: boolean;
  slackChatTiming: 'immediate' | 'unanswered';
  slackChatUnansweredMinutes: number;
  slackChatConnected: boolean;
  slackUserEmail: string | null;
}

export type ChatOAuthChannel = 'google' | 'teams' | 'slack';

export interface ChatOAuthDialogState {
  open: boolean;
  severity: 'success' | 'error';
  channel: ChatOAuthChannel;
  message: string;
}

export const defaultChatPrefs: ChatNotificationPreferences = {
  emailEnabled: true,
  emailTiming: 'unanswered',
  emailUnansweredMinutes: 2,
  googleChatEnabled: false,
  googleChatTiming: 'unanswered',
  googleChatUnansweredMinutes: 2,
  googleChatConnected: false,
  googleUserEmail: null,
  teamsChatEnabled: false,
  teamsChatTiming: 'unanswered',
  teamsChatUnansweredMinutes: 2,
  teamsChatConnected: false,
  teamsUserEmail: null,
  slackChatEnabled: false,
  slackChatTiming: 'unanswered',
  slackChatUnansweredMinutes: 2,
  slackChatConnected: false,
  slackUserEmail: null,
};

export const CHAT_OAUTH_CONNECT_FAILED_MESSAGE = {
  google: 'Google Chat connection failed. Chat alerts remain enabled — try Authorise again.',
  teams: 'Microsoft Teams connection failed. Chat alerts remain enabled — try Authorise again.',
  slack: 'Slack connection failed. Chat alerts remain enabled — try Authorise again.',
} as const;

export const CHAT_OAUTH_START_FAILED_MESSAGE = {
  google: 'Could not start Google Chat connection. Please try again.',
  teams: 'Could not start Microsoft Teams connection. Please try again.',
  slack: 'Could not start Slack connection. Please try again.',
} as const;

export type SubscriptionPayloadValue =
  | boolean
  | {
      subscribed: boolean;
      subscribedByImplication: boolean;
      seen?: boolean;
    };
